module.exports = __webpack_public_path__ + "static/img/gold.f96af9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gold.png
// module id = rxfZ
// module chunks = 1